import React, { useState, useEffect } from "react";
import { Produto } from "./Types";
import ListaSelected from "./listaselected";
import { useMask } from "@react-input/mask";
import { Box, Checkbox, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Tab, Tabs, TextField } from "@mui/material";
import apiConnect from "../api/apiConnect";

interface ValeEstornoProps {
  updateData?: (data: Produto[]) => void;
  onCheckboxChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  produtos?: Produto[];
  onConfirm?: () => void;
  tipoPix?: string | null;
  chavePix?: string;
  bank?: string | null;
  cpfcnpj?: string;
  accont?: string;
  agency?: string;
  typebank?: string;
  updateTipoPix: (tipoPixValue: string | null) => void;
  updateChavePix: (chavePixValue: string) => void;
  updateBank: (bankValue: string | null) => void;
  updateCpfcnpj: (cpfcnpjValue: string) => void;
  updateAccont: (accontValue: string | null) => void;
  updateAgency: (agencyValue: string) => void;
  updateTypeBank: (typebankValue: string | null) => void;
}

interface Bank {
  id: number;
  name: string;
}

interface BankType {
  id: number;
  name: string;
}

const ValeEstorno: React.FC<ValeEstornoProps> = ({
  updateData,
  onCheckboxChange,
  produtos,
  onConfirm,
  updateTipoPix,
  updateChavePix,
  updateBank,
  updateCpfcnpj,
  updateAccont,
  updateAgency,
  updateTypeBank,
}) => {
  const [activeTab, setActiveTab] = useState<string>("pix");
  const [tipoPix, setTipoPix] = useState<string | null>(null);
  const [chavePix, setChavePix] = useState("");
  const [data, setData] = useState<{ banks: Bank[]; banks_types: BankType[] }>({
    banks: [],
    banks_types: [],
  });
  const [bank, setBank] = useState<string>("");
  const [cpfcnpj, setCpfcnpj] = useState<string>("");
  const [accont, setAccont] = useState<string>("");
  const [agency, setAgency] = useState<string>("");
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setTipoPix("");
    setChavePix("");
    setBank("");
    setCpfcnpj("");
    setAccont("");
    setAgency("");
  };

  const handleGetBanks = async () => {
    await apiConnect.apiAPP
      .get("/banks")
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching banks:", error);
      });
  };

  useEffect(() => {
    handleGetBanks();
  }, []);

  const tellMask = useMask({ mask: "(99) 99999-9999", replacement: "9" });
  return (
    <Box>
      <Box display={"flex"} justifyContent={"center"} alignItems={"center"} marginBottom={4}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => handleTabChange(v)}
          TabIndicatorProps={{ style: { background: "#c2272c", height: 3 } }}
          sx={{
            ".Mui-selected": {
              color: `#c2272c !important`,
              fontWeight: "bold",
            },
          }}>
          <Tab value="pix" label="Pix" />
          <Tab value="bankData" label="Dados Bancários" />
        </Tabs>
      </Box>
      {activeTab === "pix" ? (
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
          <FormControl variant="standard" sx={{ m: 1, width: { xs: "90%", md: "50%" } }}>
            <InputLabel>Tipo de PIX</InputLabel>
            <Select
              defaultValue={tipoPix ?? "#"}
              onChange={(e) => {
                updateTipoPix(e.target.value);
                setTipoPix(e.target.value);
                setChavePix("");
              }}>
              <MenuItem value="#" disabled color="#ccc">
                Selecione o tipo
              </MenuItem>
              <MenuItem value={"Celular"}>Celular</MenuItem>
              <MenuItem value={"CPF ou CNPJ"}>CPF ou CNPJ</MenuItem>
              <MenuItem value={"Chave Aleatória"}>Chave Aleatória</MenuItem>
              <MenuItem value={"E-mail"}>E-mail</MenuItem>
            </Select>
          </FormControl>
          {tipoPix?.length > 0 ? (
            <TextField
              sx={{ m: 1, width: { xs: "90%", md: "50%" } }}
              variant="standard"
              label={tipoPix}
              value={chavePix}
              placeholder="Insira a chave PIX"
              inputProps={tellMask}
              onChange={(e) => {
                setChavePix(e.target.value);
                updateChavePix(e.target.value);
              }}
            />
          ) : null}
        </Box>
      ) : null}
      {activeTab === "bankData" ? (
        <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
          <Box display={"flex"} flexDirection={"row"} width={{ xs: "90%", md: "50%" }}>
            <FormControl variant="standard" sx={{ m: 1, width: "50%" }}>
              <InputLabel>Banco:</InputLabel>
              <Select
                defaultValue={tipoPix ?? "#"}
                onChange={(e) => {
                  setBank(e.target.value);
                  updateBank(e.target.value);
                }}>
                <MenuItem value="#" disabled color="#ccc">
                  Selecione o tipo
                </MenuItem>
                {data.banks.map((bank) => (
                  <MenuItem key={bank.id} value={bank.name}>
                    {bank.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              sx={{ m: 1, width: "50%" }}
              variant="standard"
              label={"CPF ou CNPJ"}
              value={cpfcnpj}
              placeholder="Insira o CPF ou CNPJ"
              onChange={(e) => {
                setCpfcnpj(e.target.value);
                updateCpfcnpj(e.target.value);
              }}
            />
          </Box>

          <Box display={"flex"} flexDirection={"row"} width={{ xs: "90%", md: "50%" }}>
            <TextField
              sx={{ m: 1, width: "50%" }}
              variant="standard"
              label={"Agência"}
              value={agency}
              placeholder="0000-0"
              onChange={(e) => {
                setAgency(e.target.value);
                updateAgency(e.target.value);
              }}
            />
            <TextField
              sx={{ m: 1, width: "50%" }}
              variant="standard"
              label={"Conta"}
              value={accont}
              placeholder="00.000-00"
              onChange={(e) => {
                setAccont(e.target.value);
                updateAccont(e.target.value);
              }}
            />
          </Box>

          <FormControl sx={{ width: { xs: "90%", md: "50%" }, marginTop: 2 }}>
            <FormLabel>Tipo de Conta</FormLabel>
            <RadioGroup row sx={{ width: 350 }}>
              {data.banks_types.map((bankType, i) => (
                <FormControlLabel
                  key={i}
                  value={bankType.name}
                  control={<Radio color="error" />}
                  color="#ff0000"
                  label={bankType.name}
                  onClick={() => updateTypeBank(bankType.name)}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      ) : null}

      <Box display={"flex"} flexDirection="row" justifyContent="center" alignItems="center" marginTop={4}>
        <Checkbox color="error" onChange={onCheckboxChange} disabled={chavePix.length > 3 ? false : true} />
        <p>
          Ao continuar, você declara que está de acordo com os termos da&nbsp;
          <a href="https://www.kappa.com.br/politica-de-privacidade/" target="_blank">
            lei de LGPD
          </a>
        </p>
      </Box>
    </Box>
  );
};

export default ValeEstorno;
